export const SERVICE_UNAVAILABLE_NOTICE = ' 지금은 등록을 받을 수 없습니다. 잠시 뒤에 다시 시도해 주세요.'
